export default function enableBodyScroll() {
  document.body.style.overflow = 'auto';
}
